import { useQuery } from '@tanstack/react-query';

import { AppointmentResponse } from './types';

export const getAppointmentByRoomId = async (roomId?: string) => {
  const appointment = await fetch(
    `/api/berrystreet/appointment/${roomId}`,
  ).then((response: any) => {
    if (!response.ok) {
      // soft fail.
      console.error(response);
    }
    return response.json();
  });
  if (!appointment.healthie_id) {
    return {};
  }
  const healthieAppointment = await fetch(
    `/api/healthie/appointment/${appointment.healthie_id}`,
  ).then((response: any) => {
    if (!response.ok) {
      // soft fail.
      console.error(response);
    }
    return response.json();
  });

  return {
    ...appointment,
    healthie: healthieAppointment,
  };
};

export const useAppointmentByRoomId = (roomId?: string) =>
  useQuery({
    queryKey: ['berrystreetGetAppointmentByRoomId', roomId],
    enabled: !!roomId,
    queryFn: (): Promise<AppointmentResponse> => getAppointmentByRoomId(roomId),
  });
